const selectDate = (date) => {
  return {
    type: 'SELECT_DATE',
    date
  }
};

export default selectDate;